export const getSovPosition = (positions: number[] | string[], percentages: number[]): number | string => {
  if (positions.length !== percentages.length) {
    throw new Error('Positions and Percentages should be same length');
  }

  const randomValue = Math.floor(Math.random() * 100);
  let cumulativePercentage = 0;

  for (let index = 0; index < percentages.length; index++) {
    cumulativePercentage += percentages[index];
    if (randomValue < cumulativePercentage) {
      return positions[index];
    }
  }

  return positions[0];
};
